import * as _ from 'lodash-es';
import {END, START} from '../abstract-units';
import {CellAreaType} from '../docking/cell-area-type';
import {Side} from '../edge';
import {CellActionType} from '../layout-actions/cell-action-type';
import {CellActionHistory} from './cell-action-history';
import {EdgeActionHistory} from './edge-action-history';
import {CellId} from '../cell';

/**
 * Temporary debugging logic.
 * Used to log actions made by user in the layout.
 * It should be removed when undo/redo functionality will be implemented [COMMON-415].
 */

interface DebugWindow extends Window {
    app: {
        layoutHistory: LayoutHistory
    };
}
declare const window: DebugWindow;

const BOX_EDGE_NAMING = ['top', 'right', 'bottom', 'left'];
const EDGE_ORIENTATION_NAMING = ['horizontal', 'vertical'];

export class LayoutHistory {

    public list: Array<CellActionHistory | EdgeActionHistory> = [];

    constructor() {
        window.app = window.app || {
            ...window.app,
            layoutHistory: this
        };
    }

    public add(action: CellActionHistory | EdgeActionHistory): LayoutHistory {
        this.list.push(action);

        return this;
    }

    public logToConsole(): void {
        const logs = this.list.map(action => this.getVerbalAction(action));

        console.table(logs);
    }

    private getVerbalAction(action: CellActionHistory | EdgeActionHistory): string {
        let result: string;

        if (action instanceof CellActionHistory) {
            const targetCellName: string = `cell-${action.targetAreaCellId}`;
            const targetAreaBoxEdgeName: string = BOX_EDGE_NAMING[action.targetAreaBoxEdge];

            result = `Cell-${action.cellId} ${
                action.actionType === CellActionType.CELL_DELETE
                    ? `removed`
                    : action.targetAreaType === CellAreaType.CENTER
                        ? `swapped with cell-${action.targetAreaCellId}`
                        : action.targetAreaType === CellAreaType.SIDE
                            ? `moved to the ${targetAreaBoxEdgeName} side of ${targetCellName}`
                            : `moved to the ${targetAreaBoxEdgeName} edge of ${targetCellName}`
                }`;
        } else {
            const displayPosRange: string = [
                `from ${action.movingAxisPosChange[START]}px`,
                `to ${action.movingAxisPosChange[END]}px`
            ].join(' ');

            result = `${_.capitalize(this.getDisplayEdgeName(action))} moved ${displayPosRange}`;
        }

        return result;
    }

    private getDisplayEdgeName(action: EdgeActionHistory): string {
        const getDisplayCellList = (cellIds: CellId[]) => `(${cellIds.join(', ')})`;
        const displaySides = [
            getDisplayCellList(action.sidedCellIds[Side.SECOND]),
            getDisplayCellList(action.sidedCellIds[Side.FIRST])
        ].join(' and ');

        return `${EDGE_ORIENTATION_NAMING[action.edgeAxis]} edge between cells ${displaySides}`;
    }

}
